/**
 * Protected Route Component
 * Redirects to /auth if user is not authenticated
 * Saves current location to redirect back after login
 */

import { useAuth } from './AuthContext';
import RedirectToLogin from './RedirectToLogin';

const ProtectedRoute = ({ children }) => {
  const { isAuthenticated, isLoading } = useAuth();

  // Show loading state while checking authentication
  if (isLoading) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <div className="text-center">
          <div className="inline-block animate-spin rounded-full h-12 w-12 border-b-2 border-primary-600"></div>
          <p className="mt-4 text-gray-600">Loading...</p>
        </div>
      </div>
    );
  }

  // Redirect to auth page if not authenticated, saving current location
  if (!isAuthenticated) {
    return <RedirectToLogin />;
  }

  // Render children if authenticated
  return children;
};

export default ProtectedRoute;
